// tabs functionality for FAQs divs
// document.addEventListener("DOMContentLoaded", function () {
// const tabs = document.querySelectorAll(".block__section_contact_visit_our_stores .tab");
// const tabContents = document.querySelectorAll(
//   ".block__section_contact_visit_our_stores .tab-content"
// );
// tabs.forEach((tab, index) => {
//   tab.addEventListener("click", function () {
//     tabs.forEach((t) => t.classList.remove("active"));
//     tab.classList.add("active");
//     tabContents.forEach((tc) => tc.classList.remove("active"));
//     if (tabContents[index]) {
//       tabContents[index].classList.add("active");
//     }
//   });
// });
// });

document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".block__section_contact_visit_our_stores");
  if (!wrapper) return;

  const tabs = wrapper.querySelectorAll(".tab");
  const tabContents = wrapper.querySelectorAll(".tab-content");
  const HEADER_OFFSET = 100; // 🔥 header height (adjust if needed)

  function activateTab(tab) {
    const index = Array.from(tabs).indexOf(tab);
    if (index === -1) return;

    tabs.forEach(t => t.classList.remove("active"));
    tabContents.forEach(tc => tc.classList.remove("active"));

    tab.classList.add("active");
    if (tabContents[index]) {
      tabContents[index].classList.add("active");
    }
  }

  /*tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      activateTab(tab);
    });
  });*/

  /* ✅ Hash based tab open + offset scroll */
  if (window.location.hash) {
    const hash = window.location.hash.replace("#", "");
    const targetTab = wrapper.querySelector(`.tab#${CSS.escape(hash)}`);

    if (targetTab) {
      activateTab(targetTab);

      /* 🔥 custom scroll with offset */
      setTimeout(() => {
        const y =
          wrapper.getBoundingClientRect().top +
          window.pageYOffset -
          HEADER_OFFSET;

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }, 150);
    }
  }
});
